/**
 * Opens Usercentrics CMP second layer for links with data-cookie-settings.
 * Navigation: set the menu item URL to #cookie-settings (or .../#cookie-settings).
 */
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('a[data-cookie-settings="true"]');
  if (!trigger) return;

  event.preventDefault();

  if (window.UC_UI && typeof window.UC_UI.showSecondLayer === 'function') {
    window.UC_UI.showSecondLayer();
  }
});
